import {Injectable} from '@angular/core';
import {DaoGeneric} from '@Services/base/daoService';
import {environment} from '@Env/environment';
import {HttpClient} from '@angular/common/http';
import {ResponseInstruction} from './response-instruction.model';
import {Observable, Subject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class InstructionService extends DaoGeneric<ResponseInstruction> {
  private url = `${environment.baseUrl}/demat/instruction/`;
  public instructionChangedSubject = new Subject<boolean>();
  onInstructionChanged$ = this.instructionChangedSubject.asObservable();
  constructor(private httpClient: HttpClient) {
    super(httpClient);
  }

  getRootUrl(): string {
    return this.url;
  }

  public getLastInstruction(response_id: string): Observable<ResponseInstruction> {
    const params = { 'response_id': response_id };
    const url = `${this.getRootUrl()}get_last_instruction/`;
    return this.httpClient.get<ResponseInstruction>(url, {params});
  }
}
